import { render, staticRenderFns } from "./Ping.vue?vue&type=template&id=2cc36371&scoped=true&"
import script from "./Ping.vue?vue&type=script&lang=js&"
export * from "./Ping.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cc36371",
  null
  
)

export default component.exports